import React from 'react';
import PropTypes from 'prop-types';
import useLabels from '@/lib/hooks/swr/useLabels';
import { useQueryProvider } from '@/modules/QueryProvider';
import laggy from '@/utils/swr/laggy';

const LabelManagementContext = React.createContext();

export const useLabelManagementContext = () =>
  React.useContext(LabelManagementContext);

export function LabelManagementProvider({ children }) {
  const { query } = useQueryProvider();

  const {
    create,
    data: labels,
    error,
    isLagging,
    isLoading,
    remove,
    total,
    update,
  } = useLabels(
    {
      labelName: query.labelName || undefined,
      pageFrom: (query.page - 1) * query.pageSize,
      pageSize: query.pageSize,
    },
    { use: [laggy] },
  );

  const value = React.useMemo(
    () => ({
      create,
      error,
      isLagging,
      isLoading,
      labels,
      remove,
      total,
      updateLabel: update,
    }),
    [create, error, isLagging, isLoading, labels, remove, total, update],
  );

  return (
    <LabelManagementContext.Provider value={value}>
      {children}
    </LabelManagementContext.Provider>
  );
}

LabelManagementProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LabelManagementContext;
